// const _url = "http://139.159.227.77:8080/baseServer";
/* import { environment } from '../environments/environment';
let host = window.location.host;
host = host.indexOf(':') !== -1 ? host.substring(0, host.indexOf(':')) : host;
host = '//' + host;
const devApis = ['http://localhost', '//192.168.21.116'];

// const prodApis=['http://192.168.195.121']

//let _url = '//192.168.195.121/api/baseServer';
let _url = devApis.indexOf(host) !== -1 ? dev : environment.apiBaseUrl + '/api/baseServer';
let _urlTwo = devApis.indexOf(host) !== -1 ? '//192.168.21.116/api/' : environment.apiBaseUrl + '/api';
let baseServerURL = devApis.indexOf(host) !== -1 ? dev : environment.apiBaseUrl + '/api/baseServer';
 */

// const devHost = '139.9.150.166'; // DEV
//const devHost = '//dev.mammasay.com'; // 测试
const devHost = '//139.9.150.166:8080'; // UAT

let host = window.location.host;
let _url: string;
let _urlTwo: string;
let _protocol = window.location.protocol;

switch (host) {
  case 'localhost:4200':  // 开发环境
  case 'localhost:63342':
    _url = `${_protocol}//${devHost}/api/tardBaseServer`;
    _urlTwo = `${_protocol}//${devHost}/api`;
    break;

  default: // 生产环境  或未配置的域名采用当前的域名做为服务的URL
    _url = `${_protocol}//${host}/api/tard2BaseServer`;
    console.log(host)
    _urlTwo = `${_protocol}//${host}/api`;
    break;
}

const api = {
  login: `${_url}/baseLoginService/login`, // 登录
  querySSO: `${_url}/baseSystemSsoService/find`, // SSO系统查询
  ssoLink: `${_url}/baseSystemSsoService/sso/`,
  functionsso: `${_url}/baseSystemSsoService/functifindByNameonsso/`,
  functionssoCollection: `${_url}/baseSystemSsoService/functionsso/`, // 收藏夹旧系统跳转
  wxLogin: `${_url}/wxLoginService/login`, //  微信登录
  getQrCodeUrl: `${_url}/wxLoginService/getQrCodeUrl`, //  微信获取url
  CarouselList: `${_url}/baseCmsCarouselService/findList`, //  轮播图

  findNews: `${_url}/baseCmsArticleService/findNews`, //  公司新闻
  findNotice: `${_url}/baseCmsArticleService/findNotice`, //  通知公告
  newsFindById: `${_url}/baseCmsArticleService/findById`, //  新闻详情
  newsFind: `${_url}/baseCmsArticleService/find`, //  列表

  findByName: `${_url}/wxCPUserListSyncService/findByName`, //  根据名字模糊查询通讯录列表
  findByCondition: `${_url}/wxCPUserListSyncService/findByCondition`, //  根据名字或手机号或邮箱 查询通讯录
  findMenuList: `${_url}/baseMenuService/findMenuList`, // 页面 菜单查询

  /*修改密码*/
  changePassword: `${_url}/baseUsersService/changePassword`,
  getCheckCode: `${_url}/baseUsersService/getCheckCode`, // 获取验证码
  passwordReminder: `${_url}/baseUsersService/passwordReminder`, // 忘记密码
  addCollection: `${_url}/baseFunctionCollectionService/addCollection`,
  deleteUserCollection: `${_url}/baseFunctionCollectionService/deleteUserCollection`,
  collectFind: `${_url}/baseFunctionCollectionService/findUserCollection`,
  allCollect: `${_url}/baseFunctionCollectionService/find`,
  findMenuListAll: `${_url}/baseFunctionCollectionService/findMenuList`, // 收藏夹菜单查询
  menuClickCount: `${_url}/baseMenuService/menuClickCount`, // 菜单统计
  imgDelete: `${_url}/fileUploadService/imgDelete`, // 图片删除
  imgUpload: `${_url}/fileUploadService/imgUpload`, // 图片保存
  userSave: `${_url}/baseUsersService/save`, // 用户信息保存
  findById: `${_url}/baseUsersService/findById`, // 查找用户信息保存
  RSA: `${_url}/generateSigatureService/generateSigature`, // 网易邮箱 RSA加密服务
  unreadMailBy163: `${_url}/generateSigatureService/unreadMail`, // 网易邮箱未读邮件服务

  getTokenByQQ: `${_url}/generateSigatureService/getToken`, // 获取QQ企业邮箱Tonken
  getNewMailByQQ: `${_url}/generateSigatureService/unreadQQMail`, // 获取QQ企业邮箱新邮件
  getLoginUrlByQQ: `${_url}/generateSigatureService/getQQMailURL`, // 获取 QQ企业登录

  findTodoTasks: `${_urlTwo}/bpmServer/bpmTaskService/findTodoTasks`, // 流程待办任务查询
  findNotifyTasks: `${_urlTwo}/bpmServer/bpmNotifyTaskService/findNotifyTasks`, // 流程阅任务查询
  findBpmLists: `${_urlTwo}/bpmServer/bpmListService/findBpmLists`, // 我的流程
  getTaskUrl: `${_urlTwo}/bpmServer/bpmProcessService/getTaskUrl`, // 我的待办和待阅流程
  getStartUrl: `${_urlTwo}/bpmServer/bpmProcessService/getStartUrl`, // 我的流程
  // findMenuList: `${_url}/baseFunctionCollectionService/findMenuList`,//收藏夹菜单查询

  getTaskUrlByTaskIds: `${_urlTwo}/bpmServer/bpmProcessService/getTaskUrlByTaskIds`, // 批量查询待办列表的实际URL
  getStartUrlByListIds: `${_urlTwo}/bpmServer/bpmProcessService/getStartUrlByListIds` // 批量查询我的流程列表的实际URL

};

export default api;



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/api.ts